import { render } from "./ExitModal.vue?vue&type=template&id=2e2cc748"
import script from "./ExitModal.vue?vue&type=script&lang=js"
export * from "./ExitModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/dash/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__